import React from 'react';
import PropTypes from 'prop-types';

import { AppContextProvider } from './AppContext';
import { ProfileProvider } from './ProfileContext';
import { HomeProvider } from './HomeContext';
import { LocationProvider } from './LocationContext';
import { MitraProvider } from './MitraContext';
import { ReviewProvider } from './ReviewContext';

const AppContext = ({ children }) => (
  <AppContextProvider>
    <LocationProvider>
      <MitraProvider>
        <ProfileProvider>
          <ReviewProvider>
            <HomeProvider>{children}</HomeProvider>
          </ReviewProvider>
        </ProfileProvider>
      </MitraProvider>
    </LocationProvider>
  </AppContextProvider>
);

AppContext.propTypes = { children: PropTypes.node.isRequired };
export default AppContext;
